import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

// Fusion sûre de classes Tailwind (clsx + tailwind-merge). Partagé par toutes les primitives UI.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const numberFormatter = new Intl.NumberFormat('fr-FR')
export const formatNumber = (value: number) => numberFormatter.format(Math.round(value))
